<script lang="ts" setup>
  import { ExternalRoute } from "@/constants/externalRoute"
  import Link from "@/components/ui/link/Link.vue"
</script>
<template>
  <h4>We're sorry you've not been happy with our service.</h4>
  <p>
    If you would like to seek independent advice, please see
    <Link class="link text-primary-600" :to="ExternalRoute.unhappy"
      >our guide on the next steps you can take</Link
    >
    . If you'd prefer to discuss this with someone, please email us at
    <Link class="link text-primary-600" to="mailto:help@so.energy"
      >help@so.energy</Link
    >
    or use the online chat to speak to an agent (available weekdays, 9am-5pm).
    Otherwise, you can proceed to cancel your switch.
  </p>
</template>
